<template>
  <header max-height="50%">
    <w-flex grow class="smd-column">
      <div :class="getClass()">{{ env }}</div>
      <div class="smd-xs12 md9 d-flex mya " 
           >
        <img 
          class="logo mxa mb0"
          src="@/assets/ambrogio_robot_logo.png"
          alt="logo"
        />
      </div>
      <div class="d-blocksmd-xs10 mdu-xs6 md3">
        <LoginForm/>
        <w-flex
          v-if="store.currentUser.isLoggedIn"
          class="justify-center align-middle"
        >
          <label class="box mya position-relative" color="primary"
            >{{ optionsStore.state.timezoneBrowser }} &nbsp;</label
          >
          <w-switch
            class="mr6"
            v-model="optionsStore.state.UTC"
            label="UTC"
            @update:model-value="
              (value) => optionsStore.switchUTCTimeZone(value)
            "
          ></w-switch>
        </w-flex>
      </div>
    </w-flex>
  </header>
</template>

<script>
import LoginForm from "@/components/Login/LoginForm";
import { optionsStore } from "@/store/options";
import { store } from "@/utils/store";

export default {
  name: "MainHeader",
  components: {
    LoginForm,
  },

  // setup: () => {
  //   return {
  //     optionsStore,
  //   };
  // }
  data() {
    optionsStore.init();
    let env = window.__env.back_end.enviroment;
    function getClass() {
      console.log('ENV 2: ', this.env);

      const base = "text-upper text-bold cr cr-top cr-left";        
      const map = {
        "local": `${base} cr-grey`,
        "svil": `${base} cr-blue`,
        "svil-01": `${base} cr-blue`,
        "pre-test": `${base} cr-orange`,
        "pre-test-01": `${base} cr-orange`,
        "test": `${base} cr-red`,
        "test-01": `${base} cr-red`,         
        "prod": `${base} cr-zcs`,      
        "prod-01": `${base} cr-zcs`,
        "prod-02": `${base} cr-zcs`,
        
      };
    
      return map[this.env] || base;
    }
    return {
      optionsStore,
      store,
      env,
      getClass,
    };
  },
};
</script>

<style scoped>
.logo {
   height: 70%;
  max-width: 100%; /* Ensures the image doesn't exceed its original size */
  width: auto; /* Allows the image to resize while maintaining its aspect ratio */

    min-height:10vh;
    max-height:12vh;
}

/* Add media query for smaller screens if needed */
@media (max-width: 768px) {
  .logo {
    height: 50%; /* Adjust the height for smaller screens */
  }
}
#loginForm {
  font-size: smaller;
}
header {
  
  height:auto;
}

body {
  background: #f0f0f0;
  font-family: sans-serif;
  
}

.cr {
  width: 200px;
  padding: 16px;
  position: absolute;
  text-align: center;
  color: #f0f0f0;
}

.cr-sticky {
  position: fixed;
  z-index:3000;
}
.cr-scroll {
  opacity: 0.8;
}

/* Positions */

.cr-top {
  top: 25px;
}
.cr-bottom {
  bottom: 25px;
}
.cr-left {
  left: -50px;
}
.cr-right {
  right: -50px;
}

/* Rotations */

.cr-top.cr-left,
.cr-bottom.cr-right {
  transform: rotate(-45deg);
}

.cr-top.cr-right,
.cr-bottom.cr-left {
  transform: rotate(45deg);
}

/* Colors */

.cr-white {
  background-color: #f0f0f0;
  color: #444;
}
.cr-black {
  background-color: #333;
}
.cr-grey {
  background-color: #999;
}
.cr-blue {
  background-color: #39d;
}
.cr-green {
  background-color: #2c7;
}
.cr-turquoise {
  background-color: #1b9;
}
.cr-purple {
  background-color: #95b;
}
.cr-red {
  background-color: #e43;
}
.cr-orange {
  background-color: #e82;
}
.cr-yellow {
  background-color: #ec0;
}
.cr-zcs {
  background-color: steelblue
}
</style>
